import React from 'react';
import Text from '.';
import { Button } from 'react-bootstrap';

const TextLink = ({text, activeClass, size, color, onClick, separator, id, action, children}) => {
    return(
        <Button 
            variant="link" 
            id={id} 
            onClick={(e) => onClick(e, action)} 
            className={`text-link ${separator} ${activeClass}`}>
            <Text 
                ownClass={`title-head `}
                text={text}
                size={size}
                color={color}
            />
            {children}
        </Button>
    )
}

export default TextLink;